// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__1LepI","content":"Footer_content__3ml2P"};